import type { GameLaunchMode } from '@/utils/url/game-launch-mode';

export const POST_LOGIN_ACTION_TYPE = {
    ADD_FAVORITE: 'addFavorite',
    LAUNCH_GAME: 'launchGame',
    OPEN_DEPOSIT: 'openDeposit'
} as const;
export type PostLoginAction =
    | { type: typeof POST_LOGIN_ACTION_TYPE.ADD_FAVORITE; uid: string }
    | { type: typeof POST_LOGIN_ACTION_TYPE.LAUNCH_GAME; url: string; launchMode?: GameLaunchMode }
    | { type: typeof POST_LOGIN_ACTION_TYPE.OPEN_DEPOSIT };

const STORAGE_KEY = 'postLoginAction';
export const openDepositSafely = async (triggerDeposit: () => Promise<void>): Promise<void> => {
    try {
        await triggerDeposit();
    } catch {
        // Swallow: the deposit overlay logs its own failures and
        // we don't want to leak this into the surrounding UI.
    }
};

export const setPostLoginAction = (action: PostLoginAction) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(action));
};

export const getPostLoginAction = (): PostLoginAction | null => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw) as PostLoginAction;
    } catch {
        return null;
    }
};

export const clearPostLoginAction = () => {
    sessionStorage.removeItem(STORAGE_KEY);
};
